import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar/Navbar";
import Banner from "../components/body/homePageComponents/Banner";
import HotLocations from "../components/body/homePageComponents/HotLocations";
import LatestUpdates from "../components/body/homePageComponents/LatestUpdates";
import Testimonials from "../components/body/homePageComponents/Testimonials";
import TopDevelopers from "../components/body/homePageComponents/TopDevelopers";
import WhychooseUs from "../components/body/homePageComponents/WhyChooseUs";
import Main_Footer from "../components/footer/IndiaFooter/Main_Footer";
import Overview from "../components/body/homePageComponents/Overview";
import HotProjects from "../components/body/homePageComponents/HotProject"; // Fixed Import Path
import OurPresence from "../components/body/homePageComponents/OurPresence";
import WhatsAppWidget from "../components/Navbar/Whatsapp";
import { Toaster } from "react-hot-toast";

import {
  bannerData,
  LatestUpdate,
  testimonialsData,
  topDevelopersData,
  whyshouldChooseData,
  OverviewData,
  OurPresenceData,
  hotlocationData,
  HotProjectsData,
  whatsapp,
} from "./data";
import Latestupdates2 from "../components/body/homePageComponents/Latestupdates2";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Property Station | Best Real Estate Consultant in Gurugram, Pune, Bengaluru And Mumbai</title>
        <meta name="description" content="Looking for your dream home in Gurugram? Property Station offers a wide range of apartments for sale, from cozy 1 BHK to luxurious 4 BHK apartments. Discover the best real estate deals in Gurugram!" />
        <meta name="keywords" content="Property Station, Property Station Gurgaon, best real estate agent in gurgaon, best real estate company in gurgaon, best property consultant, top real estate agent, top real estate agency, property expert, Property Station Pune, Property Station Bengaluru, Property Station Mumbai" />
        <link rel="canonical" href="https://propertystation.in/" />
        <meta name="geo.placename" content="Gurgaon, Delhi NCR, India" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://propertystation.in/" />
        <meta property="og:title" content="Property Station | Best Real Estate Consultant in Gurugram, Pune, Bengaluru And Mumbai" />
        <meta property="og:description" content="Looking for your dream home in Gurugram? Property Station offers a wide range of apartments for sale, from cozy 1 BHKs to luxurious 4 BHKs. Discover the best real estate deals in Gurugram!" />
        <meta property="og:image" content="https://propertystation.in/assets/logo-XC5RdgT4.png" />
        <meta name="twitter:card" content="summary" />
    <meta name="twitter:site" content="https://x.com/i/flow/login?redirect_after_login=%2FProp_Station" />
    <meta name="twitter:title" content="Property Station - Trusted Real Estate Experts" />
    <meta name="twitter:description" content="Looking for your dream home in Gurugram? Property Station offers a wide range of apartments for sale, from cozy 1 BHK to luxurious 4 BHK apartments. Discover the best real estate deals in Gurugram!" />
    <meta name="twitter:image" content="https://propertystation.in/assets/1-Dz-wte9W.webp" />
        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Property Station",
            "url": "https://propertystation.in/",
            "logo": "https://propertystation.in/assets/logo-XC5RdgT4.png",
            "image": ["https://propertystation.in/assets/1-Dz-wte9W.webp"],
            "telephone": "9999416316",
            "email": "info@propertystation.in",
            "priceRange": "Ask For Price",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Office No. 610, 6th-Floor, Sohna Road, Sector 48, Gurgaon",
              "addressLocality": "Gurugram",
              "addressRegion": "Haryana",
              "addressCountry": "India",
              "postalCode": "122001"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 28.408623,
              "longitude": 77.041876
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              "opens": "10:00",
              "closes": "18:30"
            },
            "openingHours": ["Monday-Sunday 10:00-18:30"],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "9999416316",
              "contactType": "Real estate agent",
              "areaServed": "IN",
              "availableLanguage": "en"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "bestRating": "5.0",
              "worstRating": "1.0",
              "ratingCount": "4125"
            },
            "review": {
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5.0",
                "bestRating": "5.0",
                "worstRating": "1.0"
              },
              "author": {
                "@type": "Person",
                "name": "Property Station"
              },
              "reviewBody": "Clients"
            },
            "sameAs": [
              "https://www.facebook.com/propertystationfb",
              "https://www.instagram.com/officialpropertystation",
              "https://www.linkedin.com/company/propertystation",
              "https://www.youtube.com/@PropertyStationOfficial",
              "https://twitter.com/Prop_Station"
            ]
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Which is the Best Real Estate Company In Gurgaon?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Property Station is one of the best real estate companies in Gurgaon."
                }
              },
              {
                "@type": "Question",
                "name": "Who are the best real estate agents in Gurgaon?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Property Station is one of the best real estate agents in Gurgaon."
                }
              },
              {
                "@type": "Question",
                "name": "What category of properties does Property Station specialize in?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Property Station specializes in Luxury Residential Properties."
                }
              },
              {
                "@type": "Question",
                "name": "Who is the founder of Property Station?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Mr. Rohit Goyal is the Founder and Chairman of Property Station."
                }
              }
            ]
          })}
        </script>
      </Helmet>

      <Navbar />
      <Banner bannerData={bannerData} />
      <HotProjects HotProjectsData={HotProjectsData} formdata={HotProjectsData?.form_data || {}} />
      <HotLocations hotlocationData={hotlocationData} OurPresenceData={OurPresenceData} />
      <Overview OverviewData={OverviewData} />
      <WhychooseUs whyshouldChooseData={whyshouldChooseData} />
      <TopDevelopers topDevelopersData={topDevelopersData} />
      {/* <LatestUpdates LatestUpdate={LatestUpdate} /> */}
      <Latestupdates2 />
      <WhatsAppWidget whatsappdata={whatsapp} />
      <Main_Footer />

      {/* Optional Toaster for Notifications */}
      <Toaster />
    </>
  );
};

export default HomePage;
